// extracted by mini-css-extract-plugin
export default {"cls1":"MPvtXH1VHkTaFRaSbNal","cls2":"CxTlmndp1iLkbtI9E9Ut MPvtXH1VHkTaFRaSbNal","isPhone":"MEmk9tDAw4wzMoMnXHO5"};